import ArrowIcon from 'public/icons/arrow.svg'
import CheckIcon from 'public/icons/check.svg'
import CircleIcon from 'public/icons/circle.svg'
import CloseIcon from 'public/icons/close.svg'
import CountriesIcon from 'public/icons/countries.svg'
import EyeIcon from 'public/icons/eye.svg'
import EyeOffIcon from 'public/icons/eye-off.svg'
import GameIcon from 'public/icons/game.svg'
import InstagramIcon from 'public/icons/instagram.svg'
import MedalIcon from 'public/icons/medal.svg'
import MessageIcon from 'public/icons/message.svg'
import RevenueIcon from 'public/icons/revenue.svg'
import StatsIcon from 'public/icons/stats.svg'
import SupportIcon from 'public/icons/support.svg'
import TelegramIcon from 'public/icons/telegram.svg'
import WalletIcon from 'public/icons/wallet.svg'

export const iconMap = {
  arrow: ArrowIcon,
  check: CheckIcon,
  circle: CircleIcon,
  close: CloseIcon,
  countries: CountriesIcon,
  eye: EyeIcon,
  'eye-off': EyeOffIcon,
  game: GameIcon,
  instagram: InstagramIcon,
  medal: MedalIcon,
  message: MessageIcon,
  revenue: RevenueIcon,
  stats: StatsIcon,
  support: SupportIcon,
  telegram: TelegramIcon,
  wallet: WalletIcon,
} as const

export type IconName = keyof typeof iconMap
